export default {
	"autoLineComp": {
		"autoRouting": "automatic routing",
		"autoRoutingStrategy": "automatic routing strategy",
		"availableVehicleTypeInformation": "available vehicleType information",
		"departurePrice": "Default fare",
		"mutilPosPerExtraCost": "Default Kilometer Cost",
		"startPlan": "start planning",
		"vehicleTypeTips": "The number of models must be an integer greater than or equal to 0!",
		"departurePriceTips": "The default taxi price must be a number greater than or equal to 0 and up to 2 decimal places!",
		"mutilPosPerExtraCostTips": "The default multi-drop shipping fee must be a number greater than or equal to 0 and up to 2 decimal places!",
		"carCount": "Number of vehicles required!",
		"noLineTips": "No transport route planned!",
		"diffSendAddressTips": "Please select the same shipping address",
		"senderLngLatTips": "The shipping address of the waybill has no latitude and longitude information!",
		"receiverLngLat": "The delivery address of the waybill has no latitude and longitude information!",
		"confirmSendAddressTips": "Do you want to add the waybill with the same delivery place to the delivery list together?"
	},
	"billingDetailComp": {
		"orderServiceType": "Negotiated fee",
		"billingtableRouteOption": "Adjust on the dispatch list",
		"billingtableTransportOption": "Adjust on the waybill",
		"calculationInfoTitle": "Compound calculation info",
		"shareMethod": "Apportionment method",
		"adjustBillingCost": "Manual billing amount (yuan)",
		"billingDesDialog": "Billing Instructions",
		"contractInfo": "contract information",
		"projectName": "Product item",
		"offerInfo": "Quote information",
		"businessData": "business data",
		"busDt": "business hours",
		"billingDt": "billable time",
		"billingFee": "billing result",
		"exceptdealChange": "Please go to Exception Management to adjust"
	},
	"carChoiceComp": {
		"historyVehiclePre": "Model selected",
		"addNewVehiclePre": "Add a model"
	},
	"costDialogComp": {
		"event": "event",
		"detailData": "detailed data"
	},
	"deliveryExecution": {
		"askIndex": "request order",
		"actIndex": "actual order",
		"transportArrivedTotal": "Completed",
		"late": "late",
		"arrived": "arrived"
	},
	"mainHeader": {
		"deskTop": "my desktop",
		"quit": "quit",
		"changePwd": "Change Password",
		"nowPwd": "Current Password",
		"newPwd": "New Password",
		"confirmPwd": "Confirm Password",
		"confirmChange": "Confirm the changes",
		"userInfo": "User Info"
	},
	"mapTrack": {
		"downloadData": "Download tracking data"
	},
	"onwayTracks": {
		"onwaytracksData": "tracking documents",
		"onwaytracksLx": "flow direction"
	},
	"operationLogComp": {
		"noChange": "no modification"
	},
	"resourceSelector": {
		"searchCapacityTips": "Search and select existing capacity"
	},
	"switchComp": {
		"switchChange": "Click to switch"
	},
	"trackTransitDialog": {
		"tracktransitdialogCreate": "New shipping address information",
		"askArriveGoodsDt": "required arrival time"
	},
	"transitDialog": {
		"estimateArriveStationDt": "Estimated <br> Arrival Time",
		"estimateLeaveStationDt": "Estimated <br> Departure Time",
		"transitdialogInMark": "Transit <br> Inbound <br> Instructions",
		"placeholderTransitdialogInMark": "Please enter Transit Inbound Instructions",
		"transitdialogOutMark": "Outbound <br> Transfer <br> Instructions",
		"placeholderTransitdialogOutMark": "Please enter Outbound Transfer Instructions",

	}
}


// WEBPACK FOOTER //
// ./src/lang/en/components/components/components.js